import React from 'react';

export const picScrollerMouseMove =
  (pictureScroller: React.MutableRefObject<HTMLElement | null | undefined>) => (evt: React.MouseEvent) => {
    const { clientX, clientY } = evt;
    const rect = pictureScroller.current?.getBoundingClientRect();

    if (rect) {
      const originX = ((clientX - rect.left) / rect.width) * 100;
      const originY = ((clientY - rect.top) / rect.height) * 100;
      pictureScroller.current?.style.setProperty('transform', 'scale(3.3334)');
      pictureScroller.current?.style.setProperty('transform-origin', `${originX}% ${originY}%`);
    }
  };
